import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Recycle: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      aria-hidden="true"
      viewBox="0 0 48.24 48.24"
      fill="none"
      transform={`rotate(${rotation ?? 0})`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.033 17.086)">
        <path
          d="M10.0418 21.1055H5.64987C5.01585 21.1073 4.39212 20.9452 3.83919 20.635C3.28627 20.3247 2.82294 19.8768 2.49415 19.3347C2.1784 18.7902 2.01143 18.1722 2.01002 17.5428C2.00861 16.9134 2.1728 16.2947 2.48611 15.7488L10.4357 2.01035"
          stroke={color ?? 'currentColor'}
          strokeWidth="4.02003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(20.098 26.561)">
        <path
          d="M2.01001 11.6283H18.4982C19.1291 11.6234 19.7483 11.4563 20.296 11.143C20.8437 10.8297 21.3016 10.3808 21.6258 9.83936C21.9371 9.29639 22.101 8.68138 22.101 8.05547C22.101 7.42956 21.9371 6.81454 21.6258 6.27158L19.1615 2.01035"
          stroke={color ?? 'currentColor'}
          strokeWidth="4.02003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(20.098 30.147)">
        <path
          d="M8.04006 2.01001L2.01001 8.04006L8.04006 14.0701"
          stroke={color ?? 'currentColor'}
          strokeWidth="4.02003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(4.223 17.084)">
        <path
          d="M12.4485 10.243L10.2435 2.01002L2.01051 4.21702"
          stroke={color ?? 'currentColor'}
          strokeWidth="4.02003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(16.775 4.021)">
        <path
          d="M2.01035 7.66017L4.2073 3.85722C4.52277 3.30728 4.97503 2.84821 5.5202 2.52456C6.06537 2.20091 6.68494 2.02366 7.3188 2.01002C7.94781 2.00885 8.56606 2.17315 9.1115 2.48645C9.65693 2.79974 10.1104 3.25099 10.4263 3.79491L18.3518 17.5494"
          stroke={color ?? 'currentColor'}
          strokeWidth="4.02003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(24.882 11.322)">
        <path
          d="M2.01051 8.03654L10.2435 10.2435L12.4485 2.01051"
          stroke={color ?? 'currentColor'}
          strokeWidth="4.02003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  </IconWrapper>
);
